module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account--wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card ui-card form--account"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t("label_ci_trainer_add")))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "text-reader"
  }, [_vm._v("\n                                  " + _vm._s(_vm.locale.t('label_load_image')) + " ( "), _c('b', [_vm._v("max 5MB")]), _vm._v(") "), _c('i', {
    staticClass: "ti-upload"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.loadTextFromFile
    }
  })]), _vm._v(" "), (_vm.selectedImagePreview != null) ? _c('div', {
    staticClass: "ci-training-main",
    staticStyle: {
      "width": "200px",
      "height": "200px"
    }
  }, [_c('div', {
    staticClass: "ci-training",
    style: ('background-image: url(' + _vm.selectedImagePreview + ');')
  }, [_c('div', {
    staticClass: "c2",
    staticStyle: {
      "margin-left": "16px"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.selectedImagePreview == null && _vm.imageUrl != null) ? _c('div', {
    staticClass: "ci-training-main",
    staticStyle: {
      "width": "200px",
      "height": "200px"
    }
  }, [_c('div', {
    staticClass: "ci-training",
    style: ('background-image: url(' + _vm.imageUrl + ');')
  }, [_c('div', {
    staticClass: "c2",
    staticStyle: {
      "margin-left": "16px"
    }
  })])]) : _vm._e()])])]), _vm._v(" "), (_vm.allCustomCategories.length > 0) ? _c('div', [_c('div', {
    staticClass: "scrollmenu"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_choose_location')))]), _vm._v(" "), _vm._l((_vm.allCustomCategories), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.clickSelectCustomCategory(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClass(item)
    }, [_vm._v(_vm._s(_vm.isSelected(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n                              ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('label', [_c('i', [_vm._v(_vm._s(_vm.locale.t('label_choose_location_desc')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_position')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.orderNumber),
      expression: "model.orderNumber"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_ci_position'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.orderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "orderNumber", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_trainer_name')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_ci_trainer_name'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_trainer_name_en')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enName),
      expression: "model.enName"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_ci_trainer_name_en'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.enName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "enName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_training_short_desc')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.shortDescription),
      expression: "model.shortDescription"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_ci_training_short_desc'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.shortDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "shortDescription", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_training_short_desc_en')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enShortDescription),
      expression: "model.enShortDescription"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_ci_training_short_desc_en'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.enShortDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "enShortDescription", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_training_long_desc')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.longDescription),
      expression: "model.longDescription"
    }],
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "rows": "20"
    },
    domProps: {
      "value": (_vm.model.longDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "longDescription", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_training_long_desc_en')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enLongDescription),
      expression: "model.enLongDescription"
    }],
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "rows": "20"
    },
    domProps: {
      "value": (_vm.model.enLongDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "enLongDescription", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.addTraining
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_save")) + "\n                                        ")])])])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-arrow-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d833175!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Add/AddTrainerInfo.vue
// module id = 742
// module chunks = 0